import React from 'react';

/**
 * Shown when a default list came back narrowed to the clinician's own patients (the list response's
 * `restrictedToOwn`). Says so plainly, and says how to find anyone else: search is never narrowed.
 */
export default function OwnListNotice({ restricted, children }) {
    if (!restricted) {
        return null;
    }

    return (
        <div className="text-muted font-size-12 px-2 pb-2" role="status" data-testid="own-list-notice">
            {children}
        </div>
    );
}
